var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4375 0C4.9175 0 0.4375 4.48 0.4375 10C0.4375 15.52 4.9175 20 10.4375 20C15.9575 20 20.4375 15.52 20.4375 10C20.4375 4.48 15.9575 0 10.4375 0ZM11.4375 15H9.4375V13H11.4375V15ZM11.4375 11H9.4375V5H11.4375V11Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputError);
export default __webpack_public_path__ + "static/media/input_error.9804f0ed2daae72c2b1e67eb5b56a4a0.svg";
export { ForwardRef as ReactComponent };